<template>
	<div>
		<firstsceenimage :imgobj='bigimage'></firstsceenimage>
		<div ref="imgadinte1ref" class="container" style="padding: 60px;">
			<div class="row">
				<div class="col-md-4" style="text-align: right;">
					<transition v-if="isShowNavAD" name="adfadex1">
						<img v-if="imgadinte1show1" style="width: 347px;height: 393px;" src="../../static/创新.png" />
					</transition>
				</div>
				<div class="col-md-8" style="text-align: left;">
					<div style="width: 60%;height: 393px;">
						<div
							style="padding: 30px 0px 20px 10px; color: #1D1F29;font-weight: bold;font-size: 24px;letter-spacing: 5px;">
							华为云全球领先的AI技术
						</div>
						<div
							style="padding: 0px 0px 0px 10px;font-weight: 400;color: #1D1F29;line-height: 18px;opacity: 0.5;font-size: 12px;letter-spacing: 4px;">
							星链联合华为云设立创新实验室，运用领先的AI技术助力鞋行业工业互联网建设
						</div>
					</div>
				</div>
			</div>

			<div class="row" style="margin-top: 30px;">
				<div class="col-md-8" style="text-align: right;display: flex; justify-content: flex-end; ">
					<div style="width: 60%;height: 393px;">
						<div
							style="padding: 30px 0px 20px 10px; color: #1D1F29;font-weight: bold;font-size: 24px;letter-spacing: 5px;">
							鞋行业工业模型与知识沉淀
						</div>
						<div
							style="padding: 0px 0px 0px 10px;font-weight: 400;color: #1D1F29;line-height: 18px;opacity: 0.5;font-size: 12px;letter-spacing: 4px;">
							星链数据在鞋行业完善的工业模型与丰富的知识沉淀为鞋行业工业互联网建设提供强大理论与实践支持
						</div>
					</div>
				</div>
				<div class="col-md-4" style="text-align: left;">


					<transition v-if="isShowNavAD"  name="adfadex2">
						<img v-if="imgadinte1show1" style="width: 347px;height: 393px;" src="../../static/1.png" />
					</transition>
				</div>
			</div>
			<img   style="margin-top: -550px;width: 100%;" src="../../static/波浪.png" />

		</div>

		<advideo style="color: white;" title="应用服务" viewheight="200" :video="video"> </advideo>
		<adword title="解决方案案例" slotheight="490">
			<div class="flexcenter" style="padding: 10px 40px 10px 40px;">
				<div @mouseenter="swimg(0)"
					style="position: relative;width: 347px;height:473px; overflow: hidden; margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 300px;width: 300px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 奥康国际</div>
							<div style="margin-top: 30px;">
								星链工业质检解决方案帮助奥康国际降低人力成本，提升工业质检效率60%。
							</div>
						</div>

					</div>
					<img :class="[swimgbool[0]?'imgscale':'']" style="width: 347px; height: 473px;z-index: 1;"
						src="../../static/奥康国际.png">
				</div>
	<div style="width: 10px;height: 1px;"></div>	<div style="width: 10px;height: 1px;"></div>
				<div v-if="isShowNavAD"  style="position: relative;width: 347px;height:473px; overflow: hidden;">
					<div
						style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px; margin-bottom: 30px;">
						<div style="margin-top: 300px;width: 300px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 敬请期待</div>

						</div>

					</div>
					<img style="height: 473px;z-index: 1;" src="../../static/默认图片.png">
				</div>
	<div style="width: 10px;height: 1px;"></div>
				<div v-if="isShowNavAD"  style="position: relative;width: 347px;height:473px; overflow: hidden;">
					<div
						style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px; margin-bottom: 30px;">
						<div style="margin-top: 300px;width: 300px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 敬请期待</div>

						</div>

					</div>
					<img style="height: 473px;z-index: 1;" src="../../static/默认图片.png">
				</div>
	<div style="width: 10px;height: 1px;"></div>
				<div v-if="isShowNavAD" style="position: relative;width: 347px;height:473px; overflow: hidden;">
					<div
						style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px; margin-bottom: 30px;">
						<div style="margin-top: 300px;width: 300px;">
							<div style=" font-size: 24px;letter-spacing: 5px; font-weight: bold;"> 敬请期待</div>

						</div>

					</div>
					<img style="height: 473px;z-index: 1;" src="../../static/默认图片.png">
				</div>


			</div>
		</adword>
	</div>
</template>
<script>
	import firstsceenimage from '../../components/firstsceenimage.vue'
	import adword from '../../components/adword.vue'
	import bigimage from '../../static/工业互联网.png'
	import advideo from '../../components/advideo.vue'
	import video from '../../assets/video/应用服务.mp4'

	export default {
		name: 'Prointenet',
		components: {
			firstsceenimage,
			adword,
			advideo
		},
		data() {
			return {
				bigimage: bigimage,
				video: video,
				imgadinte1top: 0,
				imgadinte1show1: false,

				swimgbool: [false],
isShowNavAD:true,
			}
		},
		mounted() {

			window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件

			this.imgadinte1top = this.$refs.imgadinte1ref.offsetTop
			if (window.innerWidth < 1000) {
				this.isShowNavAD = false
			}

		},
		methods: {
			scrollHandle: function(e) {
				var _this = this
				this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
				//实际高度太晚了，所以要加上一个虚拟高度
				this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop
				//显示4ad
				if (!this.imgadinte1show1) {
					if (this.vscrolltop > this.imgadinte1top) {
						this.imgadinte1show1 = true;


					}
				}

			},
			swimg: function(index) {


				for (var i = 0; i < 6; i++) {
					if (index == i) {
						if (!this.swimgbool[index]) {
							this.$set(this.swimgbool, index, true)
						}
					} else {
						this.$set(this.swimgbool, i, false)
					}
				}

			}


		}
	}
</script>

<style>
</style>
